import './CarModelMeetBlock.scss';
import React from 'react';
import Button from '../../ui/Button/Button';
import { ButtonStyleType } from '../../../../enums/button';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
export default function CarModelMeetBlock({ fields }) {
  return (
    <div className={'container car-model-meet-block'}>
      <div className={'wrapper'} data-aos="fade-up" data-aos-offset="100">
        <div className={'imageContainer'}>
          <Image
            alt={fields?.title.value}
            field={fields.image}
            fill
            className={'imageContainer_img'}
          />
          <Image
            alt={fields?.title.value}
            field={fields?.imageMobile}
            fill
            className={'imageContainer_imgMobile'}
          />
          <div className={'content'}>
            <h2 className={'title'} data-aos="fade-up" data-aos-offset="200">
              <RichText field={fields.titleText} />
            </h2>
            <ul className={'list'}>
              {fields?.itemList?.map((item, index) => {
                return (
                  <li
                    key={item.fields.id.value}
                    className={'list_item'}
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-duration={(index + 1) * 500}
                  >
                    <p className={'list_item_value'}>{item.fields.result.value}</p>
                    <p className={'list_item_text'}>{item.fields.column.value}</p>
                  </li>
                );
              })}
            </ul>
            <div className={'buttonWrapper'} data-aos="fade-up" data-aos-offset="200">
              <a href={fields?.linkAddress?.value?.href} target="_blank" rel="noreferrer">
                <Button
                  className={'button'}
                  variant={ButtonStyleType.Secondary}
                  isShowTooltip={false}
                >
                  {fields.buttonText.value}
                </Button>
              </a>
            </div>
          </div>
        </div>
        <div className={'buttonWrapperMobile'} data-aos="fade-up">
          <a href={fields.linkAddress.value?.href} target="_blank" rel="noreferrer">
            <Button
              className={'buttonMobile'}
              variant={ButtonStyleType.Secondary}
              isShowTooltip={false}
            >
              {fields.buttonText.value}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
